import React from 'react';
import './registration.scss';
import {
	Typography,
	Grid,
	Button
} from '@material-ui/core';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import {Formik} from 'formik';
import students from "../../images/students.svg"
import * as Yup from 'yup';
import axios from "axios";
import {exams, state} from "../../data";
import RenderInputs from "../../input";

const Registration = ()=>{
	const [loading, setLoading] = React.useState(false);
	const [success, setSuccess] = React.useState(false);
	
	const submitHandler = async (values, options)=>{
		setLoading(true);
		const data = {...values};
		axios.post(`https://rootstechnosolutions.in/api/`, data)
			.then(res => {
				if(res && res.data && res.data.message === 'success'){
					options.resetForm();
					setSuccess(true);
				}
				console.log(res)
			});
	};
	// new Date().toJSON().split('.')[0].slice(0, -3)
	const inputs = [
		{type: 'text', name: 'firstName', label: 'First Name', sm: 6},
		{type: 'text', name: 'lastName', label: 'Last Name', sm: 6},
		{type: 'radio', name: 'gender', label: 'Gender', sm: 6, options: ['Male','Female']},
		{type: 'date', name: 'dob', label: 'Date of birth', sm: 6},
		{type: 'text', name: 'email', label: 'Email', sm:6},
		{type: 'text', name: 'phone', label: 'Phone', sm:6},
		{type: 'text', name: 'address1', label: 'Address 1', sm:6},
		{type: 'text', name: 'address2', label: 'Address 2', sm:6},
		{type: 'text', name: 'address3', label: 'Address 3', sm:6},
		{type: 'text', name: 'city', label: 'City', sm:6},
		{type: 'autocomplete', name: 'state', label: 'State', sm:6, options: state},
		{type: 'text', name: 'pin', label: 'PIN', sm:6},
		{type: 'autocomplete', name: 'exam', label: 'Select Exam', options: exams, value: "ISTQB® Certified Tester - Foundation Level (Syllabus 2018)"},
		{type: 'date', name: 'exam_date', sm:6, label: 'Schedule exam date'},
		{type: 'time', name: 'exam_time', sm:6, label: 'Schedule exam time'},
		{type: 'text', name: 'referBy', label: 'Referred by'}
	];
	
	const initialValues = {};
	inputs.forEach(input=> initialValues[input.name] = input.value || '');
	
	const validationSchema= Yup.object({
		firstName: Yup.string()
			.max(20, 'Must be 20 characters or less')
			.required('First name required'),
		lastName: Yup.string()
			.max(20, 'Must be 20 characters or less')
			.required('Last name required'),
		gender: Yup.string()
			.required('Gender required'),
		email: Yup.string()
			.email('Invalid email address')
			.required('Email required'),
		phone: Yup.string()
			.max(12, 'Must be 12 numbers or less')
			.required('Phone number required'),
		exam: Yup.string().required('Gender required'),
		address1: Yup.string().required('Required'),
		address2: Yup.string().required('Required'),
		address3: Yup.string().required('Required'),
		city: Yup.string().required('City Required'),
		state: Yup.string().required('State Required'),
		exam_date: Yup.string().required('Exam date required'),
		exam_time: Yup.string().required('Exam time required'),
		dob: Yup.string().required('Date of birth Required'),
		pin: Yup.number().min(100000,'Enter valid pin code').max(999999, 'Maximum 6 numbers').required('PIN Required')
	});
	return (
		<MuiPickersUtilsProvider utils={MomentUtils}>
			<div className="input-box">
				{loading && <div id="loader">
					{!success && <div className="lds-roller"><div/><div/><div/><div/><div/><div/><div/><div/></div>}
					{success && <div className="success-message">
						<Typography variant="h4" color="primary" gutterBottom>Thank you!</Typography>
						<Typography variant="subtitle1" color="textPrimary" gutterBottom>You have successfully submitted your details.<br/>
							We will get back to you soon.</Typography>
						<Button
							onClick={()=>{
								setLoading(false);
								setSuccess(false);
							}}
							variant="contained" color="primary" style={{marginLeft: 'auto'}}>Done</Button>
					</div>}
				</div>}
				<div className="content-section">
					<div></div>
					<img src={students} alt="students"/>
				</div>
				<div className="form-section">
					<Typography variant="h5" color="textSecondary" gutterBottom>
						Registration form
					</Typography>
					<Formik
						isValid={false}
						enableReinitialize
						onSubmit={submitHandler}
						validationSchema={validationSchema}
						initialValues={initialValues}>
						{({handleSubmit, isValid}) =>
							<form onSubmit={handleSubmit} noValidate autoComplete="off">
								<Grid container spacing={3}>
									<RenderInputs {...{inputs}} />
									<Grid item sm={12}>
										<Button type="submit" disabled={!isValid} variant="contained" size="large" color="primary" fullWidth>
											Submit Registration
										</Button>
									</Grid>
								</Grid>
							</form>
						}
					</Formik>
				</div>
			</div>
		</MuiPickersUtilsProvider>
	);
};
export default Registration;
